/* eslint-disable radix */
import { useDrop } from 'react-dnd';
import React, { useState, useMemo, useEffect } from 'react';

import { isEmpty, map } from 'lodash';
import {
  arrayOf, bool, func, shape, string,
} from 'prop-types';
import { TYPES, CARD_SORT_TYPES } from '../constants';
import Category from './category';

import {
  AddGroup,
  Container,
  ContainerGrid,
  Content,
  DndMessage,
  Item,
  Link,
  ScrollBar,
  Text,
} from './styles';

const ADD_GROUP = '+ Add a group';
const DND_MESSAGE = 'Drag & drop cards here to create groups or click “+ Add a group”';

const resizeGridItem = (item) => {
  const element = item;

  const grid = document.getElementsByClassName('container-grid')[0];
  if (!grid) return;

  const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
  const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
  const rowSpan = Math.ceil(
    (item.querySelector('.content').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap),
  );

  element.style.gridRowEnd = `span ${rowSpan}`;
};

const resizeAllGridItems = () => {
  const items = document.getElementsByClassName('item');

  for (let x = 0; x < items.length; x += 1) {
    resizeGridItem(items[x]);
  }
};

const CardSortCategories = (props) => {
  const {
    categories,
    hideItemName,
    onAddCategory,
    onAddItem,
    onMoveCategory,
    onMoveItem,
    onMoveCategoriesCopy,
    onRemoveCategory,
    onRemoveCategoryItem,
    onUpdateCategory,
    sortType,
  } = props;

  const [canDrop, setCanDrop] = useState(true);

  const hasCategories = useMemo(() => !isEmpty(categories), [categories]);

  const handleRemoveCategoryItem = (item, categoryId, didDrop) => {
    if (!didDrop) return;

    onRemoveCategoryItem(item, categoryId);
  };

  const setCanDropItem = (item) => (
    sortType !== CARD_SORT_TYPES.CLOSED && canDrop && item.type === TYPES.CARD_SORT_ITEM
  );

  useEffect(() => {
    if (!isEmpty(categories)) {
      window.addEventListener('resize', resizeAllGridItems);
      window.onload = resizeAllGridItems();
    }
  }, [categories]);

  const [, drop] = useDrop({
    accept: [TYPES.CARD_SORT_ITEM],
    drop: (item, monitor) => {
      const { index } = monitor.getDropResult() || { index: categories.length };

      if (item.type !== TYPES.CARD_SORT_ITEM || index === undefined) return;

      onAddCategory(item);
    },
    canDrop: (item) => setCanDropItem(item),
  });

  return (
    <Container ref={drop}>
      <ScrollBar>
        <ContainerGrid className="container-grid">
          {hasCategories && map(categories, (category) => (
            <Item
              className="item"
              key={category.id}
            >
              <Content className="content">
                <Category
                  category={category}
                  hideItemName={hideItemName}
                  onAddItem={onAddItem}
                  onMove={onMoveCategory}
                  onMoveCategoryItem={onMoveItem}
                  onRemove={onRemoveCategory}
                  onRemoveCategoryItem={handleRemoveCategoryItem}
                  onSetCanDrop={setCanDrop}
                  onMoveCopy={onMoveCategoriesCopy}
                  onUpdate={onUpdateCategory}
                  sortType={sortType}
                />
              </Content>
            </Item>
          ))}

          {sortType !== CARD_SORT_TYPES.CLOSED && (
            <AddGroup onClick={() => onAddCategory(null)}>
              <Link>
                <Text>{ADD_GROUP}</Text>
              </Link>
            </AddGroup>
          )}
        </ContainerGrid>

      </ScrollBar>

      {!hasCategories && sortType !== CARD_SORT_TYPES.CLOSED && (
        <DndMessage>
          {DND_MESSAGE}
        </DndMessage>
      )}
    </Container>
  );
};

CardSortCategories.propTypes = {
  hideItemName: bool.isRequired,
  onAddCategory: func.isRequired,
  onAddItem: func.isRequired,
  onMoveCategory: func.isRequired,
  onMoveItem: func.isRequired,
  onRemoveCategory: func.isRequired,
  onRemoveCategoryItem: func.isRequired,
  onUpdateCategory: func.isRequired,
  onMoveCategoriesCopy: func.isRequired,
  sortType: string.isRequired,
  categories: arrayOf(
    shape({
      id: string,
    }),
  ).isRequired,
};

export default CardSortCategories;
